var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"auth-layout-header"},[_c('BaseLogo',{staticClass:"auth-layout-header__logo",attrs:{"horizontal":"","dark":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }